import { Injectable } from '@angular/core';
import { PortalService } from './portal.service';
import { UserService } from './user.service';
import { forkJoin } from 'rxjs';
import { User } from '../models/user.model';
import { TranslateService } from '@ngx-translate/core';
import { LocalizationLanguage } from '../../../sb-tools/typescript/enums/localization-language.enum';
import { CommonDataService } from '../../../sb-tools/typescript/services/common-data.service';
import { GdprPortalDTO } from '../../../sb-tools/typescript/models/dto/gdpr-portal.dto';
import { AppInsightsService } from '@sb-tools/typescript/services/app-insights.service';

@Injectable()
export class InitializationService {
    communityName: string;
    portal: GdprPortalDTO;
    portals: GdprPortalDTO[];
    portalName: string;
    user: User;

    initializeError;

    constructor(
        private appInsightsService: AppInsightsService,
        private commonDataService: CommonDataService,
        private portalService: PortalService,
        private translateService: TranslateService,
        private userService: UserService,
    ) {}

    init(): Promise<any> {
        this.appInsightsService.init();
        const pathArray = window.location.pathname.split('/');

        if (pathArray.length > 1) {
            this.communityName = pathArray[1];
        }

        if (this.communityName === '404') {
            return;
        }
        return new Promise((resolve) => {
            forkJoin(this.userService.getFullInfo(), this.portalService.getPortals()).subscribe(
                (response) => {
                    this.user = response[0];
                    this.portals = response[1];
                    this.setupLanguage(this.user.localizationLanguage);
                    this.commonDataService.language = this.user.localizationLanguage;
                    resolve(true);
                },
                (err) => {
                    this.initializeError = err || true;
                    resolve(true);
                },
            );
        });
    }

    setupLanguage(language) {
        switch (language) {
            case LocalizationLanguage.norwegian:
                this.translateService.use('nb');
                break;
            case LocalizationLanguage.swedish:
                this.translateService.use('sv_SE');
                break;
            case LocalizationLanguage.danish:
                this.translateService.use('da_DK');
                break;
            default:
                this.translateService.use(undefined);
        }
    }

    getPortal(): void {
        this.portalService.getPortal(this.portalName).subscribe((portal) => {
            return (this.portal = portal);
        });
    }
}
